export default __webpack_public_path__ + "static/media/joystick.395aee1e.png";